export class Register {
  constructor(
    public firstName: string,
    public lastName: string,
    public department: string,
    public email: string,
    public password: string
  ) { }
}
